import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Table,
  Alert,
} from "react-bootstrap";

import { Header, Banner, Services, GetInTouch, Footer } from "../index";
import { GoogleAutocomplete, checkValidations } from "../helpers";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StripeCard from "./StripeCard";
import StripePayment from "./StripePayment";

import Axios from "../../Actions/Axios";
import {
  MOBILE_URL,
  API_VERSION,
  GET_ORDER_DETAILS,
  ORDER_PAYMENT,
} from "../../Actions/ApiUrls";
import { withRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { STRIPE_PK } from "../../Actions/ApiUrls";
const stripePromise = loadStripe(STRIPE_PK);
class OrderSubmit extends Component {
  constructor(props) {
    super(props);
    const { orderId } = this.props.match.params;
    this.state = {
      orderId: orderId,
      details: {},
      stripeDisabled: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    const { orderId } = this.state;
    Axios.post(MOBILE_URL + API_VERSION + GET_ORDER_DETAILS, {
      dumpsterId: orderId,
    })
      .then((res) => {
        const { status, data } = res.data;
        if (status === "success" && data.length > 0) {
          this.setState({ details: data[0], loading: false });
          window.parent.postMessage(
            {
              status: "200",
              msg: "change",
              url: window.location.origin + `/#/payment/${orderId}`,
            },
            "*"
          );
          console.log("window.parent.postMessage called");
        }
      })
      .catch((err) => {
        console.log("No Dumplster");
        this.setState({
          loading: false,
        });
      });
  }

  hideAlert = (e) => {
    // e.preventDefault();
    this.setState({
      alertVisible: false,
      alertClass: "success",
      alertMessage: "",
    });
  };

  getToken = (token) => {
    const { id } = token;
    this.setState({
      stripeDisabled: true,
    });
    const { details } = this.state;
    const { customerCost, company } = details;
    let serviceCost = {};
    if (customerCost && customerCost.length > 0) {
      serviceCost = customerCost[0];
    }

    const data = {
      token: id,
      dumpid: details._id,
      email: details.email,
      cost: serviceCost.totalPrice,
    };

    if (company._id) {
      data.serviceProviderId = company._id;
    }
    Axios.post(MOBILE_URL + API_VERSION + ORDER_PAYMENT, data)
      .then((response) => {
        try {
          const { status, data } = response.response;
          toast.error(data.message);
        } catch (error) {
          const { data, message } = response.data;
          if (data._id) {
            toast.success(message);
            this.props.history.push("/thankyou");
          } else {
            toast.error(message);
          }
        }
        this.setState({
          stripeDisabled: false,
        });
      })
      .catch((error) => {
        this.setState({
          stripeDisabled: false,
        });
        toast.error("Please try after some time");
      });
  };

  getPrice = (value) => {
    const valid = [null, "null", "", " ", undefined, "undefined", "nan", "NAN"];
    const td =
      !valid.includes(value) && !isNaN(value)
        ? `$ ${Number(value).toFixed(2)}`
        : "$ 0.00";
    return td;
  };
  render() {
    const { data } = this.props;
    const { details, stripeDisabled, loading } = this.state;
    const serviceProviderCost = details.customerCost;
    let serviceCost = {};
    if (serviceProviderCost && serviceProviderCost.length > 0) {
      serviceCost = serviceProviderCost[0];
    }

    return (
      <Fragment>
        <Elements stripe={stripePromise}>
          {/* {data.orderTopBannerImage && (
          <Image src={data.orderTopBannerImage} style={{ width: "100%" }} />
        )} */}
          {loading ? (
            <section className="order-form">
              <Container fluid>
                <img
                  src={require("../../assets/loading.gif")}
                  style={{ width: "3%" }}
                />
              </Container>
            </section>
          ) : (
            <section className="order-form">
              <Container fluid>
                {!details._id ? (
                  <p className="error">Please try after some time</p>
                ) : (
                  <Row>
                    <Col md={8} className="order-details">
                      <h3>
                        <strong>GUARANTEED PRICE QUOTE DETAILS</strong>
                      </h3>
                      <p>
                        100% Refund if you cancel more than 24 hours before your
                        Drop off date
                      </p>
                      {details && (
                        <Fragment>
                          <Table
                            striped
                            bordered
                            hover
                            size="sm"
                            className="payment-order"
                          >
                            <tbody>
                              <tr>
                                <th colSpan={4} className="title">
                                  Customer details
                                </th>
                              </tr>
                              <tr>
                                <th>First name</th>
                                <th>Last name</th>
                                <th>Cell Phone</th>
                                <th>Other Phone</th>
                                {/* <th>City</th>
                                <th>ZipCode</th> */}
                              </tr>
                              <tr>
                                <td>{details.fName || ""}</td>
                                <td>{details.lName || ""}</td>
                                <td>{details.phoneNumber}</td>
                                <td>{details.phoneNumber2 || "NA"}</td>
                                {/* <td>{details.cityService?.muniName || ""}</td>
                                <td>{details.zipCode || ""}</td> */}
                              </tr>
                              <tr>
                                <th colSpan={2}>City</th>
                                <th colSpan={2}>ZipCode</th>
                              </tr>
                              <tr>
                                <td colSpan={2}>{details.cityService?.muniName || ""}</td>
                                <td colSpan={2}>{details.zipCode || ""}</td>
                              </tr>
                              <tr>
                                <th>Email</th>
                                <th>Company if Applicable</th>
                                <th>Title if Applicable</th>
                                <th>Best Way to Contact You</th>
                                {/* <td>{details.startLocationAddr || ""}</td> */}
                              </tr>
                              <tr>
                                <td>{details.email}</td>
                                <td>{details.companyTitle}</td>
                                <td>{details.companyInfo}</td>
                                <td>{details.bestContact}</td>
                              </tr>
                              <tr>
                                <th>Other Information</th>
                                <th>Service Address</th>
                                <th>Order agent</th>
                                <th>How Did you of Us</th>
                              </tr>
                              <tr>
                                <td>{details.anyOtherInfo || ""}</td>
                                <td>{details.startLocationAddr || ""}</td>
                                <td>{details.agentName || "Customer"}</td>
                                <td>{details.hearAboutUs}</td>
                              </tr>
                              <tr>
                                <th colSpan={4} className="title">
                                  Service Order details
                                </th>
                              </tr>
                              <tr>
                                <th>Dumpster or Service Ordered</th>
                                <th> Material Type</th>
                                <th> Drop Off Date</th>
                                <th> Drop Off Time</th>
                              </tr>
                              <tr>
                                <td>
                                  {details.dumpsterSizeService &&
                                    details.dumpsterSizeService.name}
                                </td>
                                <td>
                                  {" "}
                                  {details.materialType &&
                                    details.materialType.name}
                                </td>
                                <td>{details.dropDate}</td>
                                <td>{details.dropTime}</td>
                              </tr>
                              <tr>
                                <th> Drop Off Space</th>
                                <th> Drop Off Access</th>
                                <th> Pick Up Date</th>
                                <th> Pick Up Time</th>
                              </tr>
                              <tr>
                                <td>{details.dropOn}</td>
                                <td>{details.dropAccess}</td>
                                <td>{details.pickDate}</td>
                                <td>{details.pickTime}</td>
                              </tr>
                              <tr>
                                <th colSpan={2} className="title">
                                  Payment Details
                                </th>
                                <th colSpan={2} className="title">
                                  Potentials Additionl Cost
                                </th>
                              </tr>
                              <tr>
                                <th>
                                  <b>Number Of Days Service Required</b>
                                </th>
                                <td>{serviceCost.numberOfDaysService || 0}</td>
                                <th>Number Extra Days</th>
                                <td>{serviceCost.numberExtraDays || 0}</td>
                              </tr>
                              <tr>
                                <th>
                                  <b>Minimun 7 days Price</b>
                                </th>
                                <td>{this.getPrice(serviceCost.weekprice)}</td>
                                <th>Extra Ton Price</th>
                                <td>
                                  {this.getPrice(serviceCost.extratonPrice)}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  <b>Number of Extra Days</b>
                                </th>
                                <td>{serviceCost.numberExtraDays || 0}</td>
                                <th>Overflow Price</th>
                                <td>
                                  {this.getPrice(serviceCost.overflowPrice)}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  <b>Extra Day(s) Price</b>
                                </th>
                                <td>
                                  {this.getPrice(
                                    serviceCost.extraDayTotalPrice
                                  )}
                                </td>
                                <th>Wait Time Price</th>
                                <td>
                                  {this.getPrice(serviceCost.waitTimePrice)}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  <b>
                                    <h5>Total Including Tax</h5>
                                  </b>
                                </th>
                                <td>{this.getPrice(serviceCost.totalPrice)}</td>
                                <th>Cancel Price</th>
                                <td>
                                  {this.getPrice(serviceCost.cancelPrice)}
                                </td>
                              </tr>
                              <tr>
                              <th></th>
                                <td></td>
                                <th>Dry Run Charge</th>
                                <td>{this.getPrice(serviceCost.dryRunCharge)}</td>
                              </tr>
                              <tr>
                                <th colSpan={4} className="title">
                                  Miscellaneous
                                </th>
                              </tr>
                             
                              <tr>
                                <th>Custom 1</th>
                                <td>{this.getPrice(serviceCost.customOne)}</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <th>Custom 2</th>
                                <td>{this.getPrice(serviceCost.customTwo)}</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <th>Custom 3</th>
                                <td>
                                  {this.getPrice(serviceCost.customThree)}
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <th colSpan={4} className="title"></th>
                              </tr>
                            </tbody>
                          </Table>
                        </Fragment>
                      )}
                    </Col>
                    <Col md={4}>
                      <section className="image-box">
                        <Row>
                          {/* <Col md={12} xs={12}>
                         <Image src={require("../../assets/img/logo.png")} />
                       </Col> */}
                          <Col md={12} xs={12}>
                            <h3>
                              {(details.dumpsterSizeService &&
                                details.dumpsterSizeService.name) ||
                                ""}
                            </h3>
                          </Col>
                          <Col md={12} xs={12}>
                            {details.dumpsterSizeService &&
                              details.dumpsterSizeService.image && (
                                <Image
                                  src={details.dumpsterSizeService.image}
                                />
                              )}
                          </Col>
                        </Row>
                      </section>
                      <section className="image-box">
                        <Row>
                          <Col md={12} xs={12}>
                            <p>
                              To Confirm your service order, Please submit you
                              Payment details
                            </p>
                          </Col>

                          <Col md={12} xs={12}>
                            <section className="payment-box">
                              <Row>
                                <Col md={12} xs={12}>
                                  <Image
                                    src={require("../../assets/img/payments.png")}
                                  />
                                </Col>
                                <Col md={12} xs={12}>
                                  <section className="payst">
                                    <p>Payment Amount</p>
                                    <p className="pay-amount">
                                      {this.getPrice(serviceCost.totalPrice)}
                                    </p>
                                  </section>
                                </Col>
                                <Col>
                                  <Fragment>
                                    {details.company && details.company._id ? (
                                      <Fragment>
                                        {serviceCost.totalPrice &&
                                        serviceCost.totalPrice > 0 ? (
                                          <Fragment>
                                            {details.paymentStatus ===
                                            "completed" ? (
                                              <p className="error">
                                                Payment Already Completed
                                              </p>
                                            ) : (
                                              <Fragment>
                                                <StripePayment
                                                  disabled={stripeDisabled}
                                                  getToken={this.getToken}
                                                />
                                                {/* <StripeCard/> */}
                                              </Fragment>
                                            )}
                                          </Fragment>
                                        ) : (
                                          <p className="error">
                                            Payment cann't be proceeded , Amount
                                            should be greater than zero. We will
                                            connect you soon
                                          </p>
                                        )}
                                      </Fragment>
                                    ) : (
                                      <p className="error">
                                        Currently no service provider available
                                        in your region. We will connect you soon
                                      </p>
                                    )}
                                  </Fragment>
                                </Col>
                              </Row>
                            </section>
                          </Col>
                        </Row>
                      </section>
                    </Col>
                  </Row>
                )}

                <ToastContainer position="top-left" />
              </Container>
            </section>
          )}
        </Elements>
      </Fragment>
    );
  }
}

export default withRouter(OrderSubmit);
